import React, { ReactElement } from 'react';
import { EntryComponentProps } from './Entry';

import WpAvatar from '../../../../../avatar/WpAvatar';

export default function DefaultEntryComponent(props: EntryComponentProps): ReactElement {
  const {
    mention,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isFocused, // eslint-disable-line @typescript-eslint/no-unused-vars
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    searchValue, // eslint-disable-line @typescript-eslint/no-unused-vars
    selectMention, // eslint-disable-line @typescript-eslint/no-unused-vars
    ...parentProps
  } = props;

  return (
    <div {...parentProps}>
      <div className="mentionSuggestionsEntryContainer">
        <WpAvatar avatar={mention.avatar} size="sm" />
        <span className="mentionSuggestionsEntryText">{mention.displayName}</span>
      </div>
    </div>
  );
}
